import React, { Suspense, lazy } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/variables.css';
import './styles/sections-shared.css';
import './styles/index.css';
import './styles/loading.css';
import AppLoading from './components/common/AppLoading';

const AppRouter = lazy(() => import('./Router'));

function App() {
  return (
    <div className="App">
      <Suspense fallback={<AppLoading />}>
        <AppRouter />
      </Suspense>
    </div>
  );
}

export default App;
